<template>
  <li class="relative pb-10">
    <e-plus
      v-if = "element.type != 'TITLE'"
      :rank="element.rank"
      v-on:add-element="addElement"
      :is-linkable="element.isLinkable"
      :is-linked="element.isLinked"
      v-on:linked="element.isLinked = true"
      v-on:unlinked="element.isLinked = false"
    ></e-plus>
    <!-- Current Step -->
    <div
      class="-ml-px absolute mt-0.5 top-4 left-4 w-0.5 h-full bg-blue-300"
    ></div>
    <div class="relative flex items-start space-x-4 group focus:outline-none">
      <div class="h-9 flex items-center">
        <span
          class="relative z-1 w-8 h-8 flex items-center justify-center
          cursor-pointer bg-white border-2 border-blue-600 rounded-full
          text-blue-600"
          v-tooltip="`Scroll to ${element.name}`"
          @click="scrollTo"
        >
          <span class="h-2.5 w-2.5 bg-blue-600 rounded-full"></span>
        </span>
      </div>
      <div class="-mt-2 w-full">
        <!-- INSERT THE APPROPRIATE ELEMENT -->
        <color-element
          :element="element"
          v-if="element.type == 'COLOR'"
        ></color-element>

        <text-element
          :element="element"
          v-if="element.type == 'TEXT'"
        ></text-element>

        <image-element
          :element="element"
          v-if="element.type == 'IMAGE'"
        ></image-element>

        <video-element
          :element="element"
          v-if="element.type == 'VIDEO'"
        ></video-element>

        <vertical-space-element
          :element="element"
          v-if="element.type == 'SPACE'"
        ></vertical-space-element>

        <audio-element
          :element="element"
          v-if="element.type == 'AUDIO'"
        ></audio-element>

         <title-element
          :element="element"
          v-if="element.type == 'TITLE'"
        ></title-element>
      </div>
    </div>
  </li>
</template>

<script>
// import Component from "../component_location"
import EPlus from "./EPlus.vue";
import ColorElement from "./ColorElement.vue";
import TextElement from "./TextElement.vue";
import ImageElement from "./ImageElement.vue";
import VideoElement from "./VideoElement.vue";
import AudioElement from "./AudioElement.vue";
import VerticalSpaceElement from "./VerticalSpaceElement.vue";
import TitleElement from "./TitleElement.vue";
import Card from "./Card.vue";
import { EventBus } from "@/utils.js";

export default {
  components: {
    EPlus,
    ColorElement,
    Card,
    TextElement,
    ImageElement,
    VideoElement,
    AudioElement,
    VerticalSpaceElement,
    TitleElement,
  },

  props: { element: { type: Object, default: () => {} } },

  data() {
    return {};
  },

  watch: {},

  methods: {
    addElement(details) {
      this.$emit("add-element", details);
    },
    scrollTo() {
      EventBus.$emit("scroll-to-element", this.element);
    },
  },

  computed: {
    lockable() {
      return this.element.rank > 0;
    },
  },

  mounted() {
    if (this.element.name == "") {
      if (this.element.type == "TITLE")  this.element.name = this.element.type;
      else this.element.name = `${this.element.type}-0${this.element.rank}`;
    }
  },
};
</script>

<style></style>
